import { OrgDto, UserDto, fakeUserDto } from "@arrowsup/platform-dtos";
import React from "react";

export interface UserContextValue {
  user: UserDto;
  /**
   * The organization the user is currently viewing. Undefined means "use the
   * default" (user.org). Must be one of user.organizations.
   */
  activeOrg?: OrgDto;
  setActiveOrg: (org: OrgDto) => void;
}

export const UserContext = React.createContext<UserContextValue>({
  user: fakeUserDto(), // Annoying, but makes types cleaner downstream.
  activeOrg: undefined,
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  setActiveOrg: () => {},
});
